import axios from "axios";

const basic_auth = window.basic_auth;
const basic_password = window.basic_password;

const BASIC_AUTH =
    "Basic " + btoa(`${basic_auth}:${basic_password}`);

const api = axios.create({
    baseURL: window.url_NOVA_API,
});

async function getToken() {
    const { data } = await axios.get(
        `${window.url_NOVA_API}/Global/v2/GetToken`,
        {
            headers: {
                Authorization: BASIC_AUTH
            },
            params: {
                ALIAS: window.novo_alias_RC
            }
        }
    );

    const token = data.TOKEN || data.token || data;

    sessionStorage.setItem("RC_NEOPAV_TOKEN", token);

    return token;
}

api.interceptors.request.use(async (config) => {
    config.params = {
        ...(config.params || {}),
        ALIAS: window.novo_alias_RC
    };

    // O endpoint de token usa Basic Auth
    if (config.url?.includes("/Global/v2/GetToken")) {
        config.headers.Authorization = BASIC_AUTH;
        return config;
    }

    let token = sessionStorage.getItem("RC_NEOPAV_TOKEN");

    if (!token) {
        token = await getToken();
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

export default api;